import { useEffect } from 'react';

const APP_NAME = 'Dory Portal';

/**
 * Sets `document.title` for pages that are not in the route registry \u2014
 * sign-in, the legal pages, not-found, and the access-denied panel. Registry
 * routes get their title from Layout instead.
 *
 * The cleanup only clears a title this hook still owns. Several of these pages
 * mount transiently while data loads (NoOrganizationAccess shows until the
 * organization list arrives), and a cleanup that reset unconditionally clobbered
 * the title Layout had already set \u2014 leaving the tab reading a bare
 * "Dory Portal" on every gated page, with no later effect to put it right.
 */
const usePageTitle = (pageTitle: string): void => {
  useEffect(() => {
    const applied = `${pageTitle} \u2014 ${APP_NAME}`;
    document.title = applied;
    return () => {
      if (document.title === applied) {
        document.title = APP_NAME;
      }
    };
  }, [pageTitle]);
};

export default usePageTitle;
